import request from '@/utils/request'
import config from '@/config'
// import axios from 'axios'
// let rootUrl = 'http://122.224.94.108:8018/service'
export default {
  // 台风接口引用
  getTyhoonActivity (params) {
    return request.get(config.ApiYJ + '/Reference/GetTyhoonActivity', { params })
  },
  // 获取台风详情
  getTyphoonInfo (params) {
    return request.get(config.ApiYJ + '/Reference/GetTyphoonInfo', { params })
  },
  // 获取雷达图
  getweatherRadar (params) {
    return request.get(config.ApiYJ + '/Reference/GetWeatherRadar', { params })
  },
  // 获取卫星云图
  getCloudPic (params) {
    return request.get(config.ApiYJ + '/Reference/GetCloudPicByNum', { params })
  },
  // 获取今日天气
  getWeatherInfo (params) {
    return request.get(config.ApiWeather + '/Reference/GetTodayWeather', { params })
  }
  // 台风接口引用
  // getTyhoonActivity (params) {
  //   return request.get('http://122.224.94.107:8065/Reference/GetTyhoonActivity', { params })
  // }
  // 查询台风信息
  // getTyhoonActivity (params) {
  //   return request.get('http://122.224.94.107:8065/Reference/GetTyhoonActivity', { params })
  // },
  // 获取台风详情
  // getTyphoonInfo (params) {
  //   return request.get('http://122.224.94.107:8065/Reference/GetTyphoonInfo', { params })
  // },
}
